import { NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RouterModule } from '@angular/router';
import { RedirectionService } from '../../services/redirection.service';

@Component({
    selector: 'app-header',
    imports: [NgOptimizedImage, RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    assetsCDNUrl = environment.assetsCDNUrl;
    _redirection = inject(RedirectionService);
    @ViewChild('navigation') navigation!: ElementRef;
    @ViewChild('headerBackdrop') headerBackdrop!: ElementRef;

    handler_hanburgerOpen() {
        this.navigation.nativeElement.classList.add('active');
        this.headerBackdrop.nativeElement.classList.add('active');
    }

    handler_hanburgerClose() {
        this.navigation.nativeElement.classList.remove('active');
        this.headerBackdrop.nativeElement.classList.remove('active');
    }
    handler_redirect(selectedTab: number) {
        this._redirection.solution.set(selectedTab);
        setTimeout(() => {
            this._redirection.handler_scroll('js-scrollContent');
        }, 500);
    }
}
